import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon6am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99997 12.7499C5.37663 12.7499 3.25 10.6233 3.25 7.99997C3.25 5.37663 5.37663 3.25 7.99997 3.25C10.6233 3.25 12.7499 5.37663 12.7499 7.99997C12.7499 10.6233 10.6233 12.7499 7.99997 12.7499ZM7.99997 13.9999C4.68628 13.9999 2 11.3137 2 7.99997C2 4.68628 4.68628 2 7.99997 2C11.3137 2 13.9999 4.68628 13.9999 7.99997C13.9999 11.3137 11.3137 13.9999 7.99997 13.9999Z"
        fill="currentColor"
      />
      <path
        d="M2 7.99997C2 11.0048 4.10236 13.4407 6.69568 13.4407C9.289 13.4407 11.3913 11.0048 11.3913 7.99994C11.3913 4.99507 9.289 2.55914 6.69568 2.55914C4.10236 2.55914 2 4.9951 2 7.99997Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.69568 12.1907C4.95918 12.1907 3.25 10.4936 3.25 7.99997C3.25 5.5063 4.95918 3.80914 6.69568 3.80914C8.43217 3.80914 10.1413 5.50627 10.1413 7.99994C10.1413 10.4936 8.43217 12.1907 6.69568 12.1907ZM6.69568 13.4407C4.10236 13.4407 2 11.0048 2 7.99997C2 4.9951 4.10236 2.55914 6.69568 2.55914C9.289 2.55914 11.3913 4.99507 11.3913 7.99994C11.3913 11.0048 9.289 13.4407 6.69568 13.4407Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon6am;
